<template>
  <div >
    <b-container fluid class="md-content">
        <div class="md-header">Plan Optionen</div>
        <b-card>
            <b-row>
                <b-col>
                    <b-button variant="success" @click="showModal('modal-createemployeerules')">Plan Optionen anlegen</b-button>
                </b-col>
                
                <b-col>
                    <b-button variant="primary" @click="refresh()">Aktualisieren</b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-if="rules != undefined">
                <b-col>
                    <b-table striped hover :borderless="true" :outlined="false" :items="rules" :fields="fields">
                        
                        <template slot="actions" slot-scope="row">
                            <b-button class="mx-1" size="sm" v-on:click="openViewModal(row.item.id)"><i class="fas fa-eye"></i></b-button>
                            
                            <b-button class="mx-1" size="sm" variant="danger" v-on:click="openDeleteModal(row)"><i class="fas fa-trash"></i></b-button>
                        </template>
                        
                    </b-table>
                </b-col>
            </b-row>
        </b-card>
    </b-container>


    <b-modal ref="modal-deleteemployeerules"  no-close-on-backdrop no-close-on-esc centered title="Plan Optionen löschen" @cancel="hideModal('modal-deleteemployeerules')" @ok="deleteEmployeeRules" cancel-title="Abbrechen">
        <b-container fluid>
            <b-row>
                <p> Sind Sie sicher dass Sie die Plan Optionen des Mitarbeiters löschen wollen?</p>
            </b-row>
            <b-row v-if="ruleserror">
                Fehler beim Löschen der Plan Optionen.
            </b-row>
        </b-container>
    </b-modal>


   <b-modal ref="modal-viewemployeerules"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Plan Optionen Detail" @cancel="hideModal('modal-viewemployeerules')" @ok="hideModal('modal-viewemployeerules')" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            <b-tabs card>
                
                <b-tab title="Plan-Optionen">
                    
                    <div v-if="employeeRulesId != undefined && employeeRulesMap[employeeRulesId] != undefined">
                        <b-row >
                             <b-col><b>Name:</b></b-col> 
                             <b-col>{{employeeRulesMap[employeeRulesId].name}}</b-col> 
                        </b-row>
                        <b-row v-if="employeeRulesMap[employeeRulesId].rules['desiredR'] != undefined">
                             <b-col><b>Mitarbeiter-Wünsche:</b></b-col> 
                             <b-col>Level {{employeeRulesMap[employeeRulesId].rules['desiredR']}}</b-col> 
                        </b-row>
                        <b-row v-if="employeeRulesMap[employeeRulesId].rules['undesiredR'] != undefined">
                            <b-col><b>Mitarbeiter-Abneigungen:</b></b-col>  
                            <b-col>Level {{employeeRulesMap[employeeRulesId].rules['undesiredR']}}</b-col> 
                        </b-row>
                        <b-row v-if="employeeRulesMap[employeeRulesId].rules['weekendR'] != undefined">
                            <b-col><b>Freie Wochenenden:</b></b-col>  
                            <b-col>Level {{employeeRulesMap[employeeRulesId].rules['weekendR']}}</b-col> 
                        </b-row>
                        <b-row v-if="employeeRulesMap[employeeRulesId].rules['weekendDaysR'] != undefined">
                            <b-col><b>Wochenendstage:</b></b-col>  
                            <b-col>Level {{employeeRulesMap[employeeRulesId].rules['weekendDaysR']}}</b-col> 
                        </b-row>
                        <b-row v-if="employeeRulesMap[employeeRulesId].rules['skillR'] != undefined">
                            <b-col><b>Skill Berücksichtigung</b></b-col>
                            <b-col>Level {{employeeRulesMap[employeeRulesId].rules['skillR']}}</b-col>  
                        </b-row>
                        <b-row v-if="employeeRulesMap[employeeRulesId].rules['fairnessDefinitionR'] != undefined">
                            <b-col><b>Fairness Bedingungen:</b></b-col>  
                            <b-col>Level {{employeeRulesMap[employeeRulesId].rules['fairnessDefinitionR']}}</b-col> 
                        </b-row>
                        <b-row v-if="employeeRulesMap[employeeRulesId].rules['bioR'] != undefined">
                            <b-col><b>Biorhythmus:</b></b-col> 
                            <b-col>Level {{employeeRulesMap[employeeRulesId].rules['bioR']}}%</b-col> 
                        </b-row>
                        
                        
                    </div>
                </b-tab>
                
            </b-tabs>
        </b-card>   
        </b-container>
    </b-modal>


    <b-modal ref="modal-createemployeerules"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Plan Optionen anlegen" @cancel="hideModal('modal-createemployeerules')" @ok="createEmployeeRules" cancel-title="Abbrechen">
        <b-container fluid>
            <div>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Name" label-for="cer0">
                        <b-form-input id="cer0" v-model="rulesName" type="text"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Vorlage" label-for="cer1">
                    <b-form-select id = "cer1" v-model="ruleTemplateId" @change="onChangeRuleTemplate">
                        <option v-bind:key ="1" v-bind:value="null">
                            Keine Vorlage
                        </option>
                         <option v-for="option in employeeRulesTemplateMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>
               
                <div v-if="ruleTemplateId != null && employeeRulesTemplateMap[ruleTemplateId] != null">
                    <b-form-group label-cols="4" label-cols-lg="4" label="Mitarbeiter-Wünsche Gewichtung" label-for="cer2" :description="'Level '+employeeRules.desiredR">
                        <b-form-input :min="employeeRulesTemplateMap[ruleTemplateId].rules['desiredR'].min" :max="employeeRulesTemplateMap[ruleTemplateId].rules['desiredR'].max" id="cer2" v-model.number="employeeRules.desiredR" type="range"></b-form-input>
                    </b-form-group>
                
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Mitarbeiter-Abneigungen Gewichtung" label-for="cer4" :description="'Level '+employeeRules.undesiredR">
                        <b-form-input :min="employeeRulesTemplateMap[ruleTemplateId].rules['undesiredR'].min" :max="employeeRulesTemplateMap[ruleTemplateId].rules['undesiredR'].max" id="cer4" v-model.number="employeeRules.undesiredR" type="range"></b-form-input>
                    </b-form-group>

                    
                
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freie Wochenenden Gewichtung" label-for="cer6" :description="'Level '+employeeRules.weekendR">
                        <b-form-input :min="employeeRulesTemplateMap[ruleTemplateId].rules['weekendR'].min" :max="employeeRulesTemplateMap[ruleTemplateId].rules['weekendR'].max" id="cer6" v-model.number="employeeRules.weekendR" type="range"></b-form-input>
                    </b-form-group>

                
                
                    <b-form-group  label-text-align="left" label-cols="4" label-cols-lg="4" label="Wochenends-Tage Gewichtung" label-for="cer8" :description="'Level '+employeeRules.weekendDaysR">
                        <b-form-input :min="employeeRulesTemplateMap[ruleTemplateId].rules['weekendDaysR'].min" :max="employeeRulesTemplateMap[ruleTemplateId].rules['weekendDaysR'].max" id="cer8" v-model.number="employeeRules.weekendDaysR" type="range"></b-form-input>
                    </b-form-group>

                    

                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Skill-Berücksichtigung" label-for="cer8" :description="'Level '+employeeRules.skillR">
                        <b-form-input :min="employeeRulesTemplateMap[ruleTemplateId].rules['skillR'].min" :max="employeeRulesTemplateMap[ruleTemplateId].rules['skillR'].max" id="cer8" v-model.number="employeeRules.skillR" type="range"></b-form-input>
                    </b-form-group>

                    
                
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Fairness Bedingung Gewichtung" label-for="cer11" :description="'Level '+employeeRules.fairnessDefinitionR">
                        <b-form-input :min="employeeRulesTemplateMap[ruleTemplateId].rules['fairnessDefinitionR'].min" :max="employeeRulesTemplateMap[ruleTemplateId].rules['fairnessDefinitionR'].max" id="cer11" v-model.number="employeeRules.fairnessDefinitionR" type="range"></b-form-input>
                    </b-form-group>

                    
                
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Biorhythmus Gewichtung" label-for="cer13" :description="'Level '+employeeRules.bioR">
                        <b-form-input :min="employeeRulesTemplateMap[ruleTemplateId].rules['bioR'].min" :max="employeeRulesTemplateMap[ruleTemplateId].rules['bioR'].max" id="cer13" v-model.number="employeeRules.bioR" type="range"></b-form-input>
                    </b-form-group>
                </div>
            </div>
           
            <b-row v-if="ruleserror">
                Fehler beim Erstellen der Plan Optionen.
            </b-row>
        </b-container>
    </b-modal>

   
  </div> 

</template>

<script>
export default {
  name: 'employeerulesoverview',
  props: ["storeId"],
  data () {
    return {
      rules: [],
      employeeRulesTemplateMap: {},
      employeeRulesMap: {},
      employeePicture: null,
      fields: [{key:"name", label:"Name", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: true}, {key:"actions", label:"", thClass: 'documentsTh', tdClass: 'documentsTd', sortable: false}],
     
      
      employeeRulesId: undefined,
      ruleTemplateId: null,
      rulesName: "",
      employeeRules: {

          desiredR: 0,
          undesiredR: 0,
          weekendR: 0,
          weekendDaysR: 0,
          skillR: 0,
          fairnessDefinitionR: 0,
          bioR: 0,
      },
      
      currentRulesRow: {},
      ruleserror: false,
    }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
        this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function(){
        let view = this;

        this.loadRuleTemplates()
        .then(response => {
            view.updateRuleTemplates(response.data);
            view.loadEmployeeRules()
            .then(response => {
                view.updateEmployeeRules(response.data);
            }).catch(function (error) {
                console.log(error)
            })  
        }).catch(function (error) {
            console.log(error)
        })  
        
    },
    onChangeRuleTemplate: function (val) {
        
        if(val != null && this.employeeRulesTemplateMap[val] != null){
            this.employeeRules = {
               
                desiredR: this.employeeRulesTemplateMap[val].rules['desiredR'].min,
                undesiredR: this.employeeRulesTemplateMap[val].rules['undesiredR'].min,
                weekendR: this.employeeRulesTemplateMap[val].rules['weekendR'].min,
                weekendDaysR: this.employeeRulesTemplateMap[val].rules['weekendDaysR'].min,
                skillR: this.employeeRulesTemplateMap[val].rules['skillR'].min,
                fairnessDefinitionR: this.employeeRulesTemplateMap[val].rules['fairnessDefinitionR'].min,
                bioR: this.employeeRulesTemplateMap[val].rules['bioR'].min,
            };
        }
    },
    createEmployeeRules: function(evt){
        evt.preventDefault();
        this.ruleserror=false;
        let view = this;
        let url = '/api/sec/employeerules';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeerules');
        let payload = {
          storeId: this.$store.state.storeId,
          name: this.rulesName,
          templateId: this.ruleTemplateId,
          rules: this.employeeRules
        }
       

        this.axios({
            method: 'post',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url,
            data: payload
        }).then(response => {
            let employeeRules = response.data.data;
            view.employeeRulesMap[employeeRules.id] = employeeRules;
            view.rules.push(employeeRules);
            
            view.hideModal('modal-createemployeerules');
        }).catch(function (error) {
            view.ruleserror=true;
            console.log(error)
        })

    },
    openDeleteModal: function(row){
        this.currentRulesRow = row;
        this.rulesName = row.item.name;
        this.employeeRulesId = row.item.id;
        this.showModal('modal-deleteemployeerules');
    },
    
    deleteEmployeeRules: function(evt){
        evt.preventDefault();
        this.ruleserror=false;
        let view = this;
        let url = '/api/sec/employeerules';
        
        url = this.$helpers.appendParam("id", this.employeeRulesId, url, '/api/sec/employeerules');
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeerules');
        
        
        this.axios({
            method: 'delete',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
            const index = this.rules.findIndex(employeeRules => employeeRules.id === view.employeeRulesId) // find the employee index 
            if (~index) {
                view.rules.splice(index, 1);
            } 
            view.deleteEmployeeRulesFromMap(view.employeeRulesId);
            view.employeeRulesId = undefined;
            view.hideModal('modal-deleteemployeerules');
        }).catch(function (error) {
            view.ruleserror=true;
            console.log(error)
        })

    },
    deleteEmployeeRulesFromMap(id){
        delete this.employeeRulesMap[id]
    },
    openViewModal: function(id){
        let view = this;
        this.employeeRulesId = id;
        view.showModal('modal-viewemployeerules');
    },
    loadEmployeeRules : function() {
      
      let url = '/api/sec/employeerules';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeerules');
     
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    loadRuleTemplates : function() {
      
      let url = '/api/sec/ruletemplate';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/ruletemplate');
      
      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    updateRuleTemplates: function(data){
        
        let templateMap = {};
        for (let i = 0; i < data.length; i++) {
            templateMap[data[i].id] =data[i];
        }
        this.employeeRulesTemplateMap = templateMap;
    },
    updateEmployeeRules: function(data){
        let overviewA = [];
        var i;
        let trules = {}
        for (i = 0; i < data.length; i++) {
            trules[data[i].id] =data[i];
             overviewA.push(data[i]);
        }
        this.employeeRulesMap = trules;
        this.rules = overviewA;
    },
    
    hideModalWithoutReset (ref) {
        this.ruleserror=false;
        this.$refs[ref].hide();
    },
    resetEmployeeRulesValues(){
        this.ruleserror=false;
        this.currentRulesRow={};
        this.rulesName = "";
        this.employeeRules = {
         
          desiredR: 0,
          undesiredR: 0,
          weekendR: 0,
          weekendDaysR: 0,
          skillR: 0,
          fairnessDefinitionR: 0,
          bioR: 0,
      }
    },
    hideModal (ref) {
        this.employeeRulesId = null;
        this.resetEmployeeRulesValues();
        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  },
  computed: {
   
  },
  watch: { 
    
  }

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>

</style>
